import src from "IMAGE";
export default { src, width: 90, height: 22, blurWidth: 0, blurHeight: 0};
